// PermissionFilters.jsx
import React from "react";
import { Box, Button } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import FilterBox from "../../../../components/common/FilterBox";

const PermissionFilters = ({
  nameFilter,
  descriptionFilter,
  handleNameFilterChange,
  handleDescriptionFilterChange,
  handleCreateClick,
}) => {
  const filterForm = [
    {
      name: "nameFilter",
      type: "text",
      placeholder: "Search by Name",
      value: nameFilter,
    },
    {
      name: "descriptionFilter",
      type: "text",
      placeholder: "Search by Description",
      value: descriptionFilter,
    },
  ];

  return (
    <Box
      sx={{ display: "flex", justifyContent: "space-between", alignItems: "center", mb: 3, flexWrap: "wrap", gap: 2 }}
    >
      <Box sx={{ display: "flex", gap: 1.5, flexWrap: "wrap" }}>
        {/* Use the FilterBox component without a search button */}
        <FilterBox
          filterForm={filterForm}
          onFilterChange={(e, index) => {
            if (index === 0) handleNameFilterChange(e);
            if (index === 1) handleDescriptionFilterChange(e);
          }}
          onFilterSubmit={(e) => e.preventDefault()} // Keep a dummy handler to prevent form submission
          className="flex flex-start gap10"
          buttonValue=""
        />
      </Box>
      <Button
        variant="contained"
        startIcon={<AddIcon />}
        onClick={handleCreateClick}
        aria-label="Create new permission"
        style={{ background: "#ED141F" }}
      >
        Create New Permission
      </Button>
    </Box>
  );
};

export default PermissionFilters;
